var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var StyledPill = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 500;\n  font-size: 1.2rem;\n  letter-spacing: 0.17px;\n  text-transform: uppercase;\n  color: ", ";\n\n  &.success {\n    font-weight: bold;\n    padding: 9px 12px;\n    color: ", ";\n    border-radius: 16px;\n    background-color: ", ";\n  }\n  &.secondary {\n    font-weight: bold;\n    padding: 9px 12px;\n    color: ", ";\n    border-radius: 16px;\n    background-color: ", ";\n  }\n  &.warning {\n    font-weight: bold;\n    padding: 9px 12px;\n    color: ", ";\n    border-radius: 16px;\n    background-color: ", ";\n  }\n"], ["\n  font-weight: 500;\n  font-size: 1.2rem;\n  letter-spacing: 0.17px;\n  text-transform: uppercase;\n  color: ", ";\n\n  &.success {\n    font-weight: bold;\n    padding: 9px 12px;\n    color: ", ";\n    border-radius: 16px;\n    background-color: ", ";\n  }\n  &.secondary {\n    font-weight: bold;\n    padding: 9px 12px;\n    color: ", ";\n    border-radius: 16px;\n    background-color: ", ";\n  }\n  &.warning {\n    font-weight: bold;\n    padding: 9px 12px;\n    color: ", ";\n    border-radius: 16px;\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.pill.text;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.pill.successText;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.pill.successBg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.pill.secondaryText;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.pill.secondaryBg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.pill.warningText;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.pill.warningBg;
});
export var Pill = function (_a) {
    var text = _a.text, className = _a.className;
    return React.createElement(StyledPill, { className: className }, text);
};
var templateObject_1;
//# sourceMappingURL=Pill.js.map